<template>
  <tf-table-parent-row>
    <tf-table-td data-test-event-type>
      <router-link
        class="cta"
        :tag="isCompleted ? 'a' : 'span'"
        :to="isCompleted
          ? {
            name: 'ProjectOverview',
            params: {
              projectId: rowData.id,
              view: 'product',
            },
          }
          : {}"
      >
        <tf-button
          type="primary"
          size="text"
          :disabled="!isCompleted"
          v-text="rowData.type"
        />
      </router-link>
      <bp-tooltip
        v-if="!isCompleted"
        placement="right"
      >
        <icon
          slot="reference"
          :name="isInSetup
            ? 'regular/clock'
            : 'exclamation-triangle'"
          class="icon"
        />
        {{ tooltipInfo.text }}
        <router-link
          v-if="!isInSetup"
          class="cta"
          :to="{
            name: 'ClientEvents',
            params: {
              eventType: tooltipInfo.type,
              projectId: rowData.id,
            },
          }"
        >
          {{ tooltipInfo.cta }}
        </router-link>
      </bp-tooltip>
      <!-- rff:activeEventsOnHome -->
      <bp-tooltip
        v-else-if="rowData.completion_risk && activeEventsFlagEnabled"
        class="tooltip-events-container"
        placement="right"
      >
        There are products that need to be marked as sold.
        <icon
          slot="reference"
          name="exclamation-circle"
          class="icon exclamation-icon"
        />
      </bp-tooltip>
    </tf-table-td>
    <tf-table-td data-test-products>
      <p
        v-for="product in rowData.products"
        :key="product"
        v-text="product"
      />
    </tf-table-td>
    <tf-table-td data-test-date>
      <span>
        {{ $TF.DatesUtils.formatSimpleDate(rowData.date, 'MM/DD/YY') || '&mdash;' }}
      </span>
    </tf-table-td>
  </tf-table-parent-row>
</template>

<script>
  /* rff:activeEventsOnHome */
  import { activeEventsOnHome } from '@/utils/featureFlags';

  export default {
    name: 'ActiveEventsRow',
    props: {
      rowData: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      activeEventsOnHome,
    }),
    computed: {
      /**
       * Evaluate and return the value of the activeEventsOnHome feature flag.
       * rff:activeEventsOnHome
       *
       * @returns {boolean}
       *
       */
      activeEventsFlagEnabled() {
        return this.$ld.checkFlags(activeEventsOnHome);
      },
      /**
       * Evaluate the data type to create an object to be used in the tooltip template.
       *
       * @returns {object}
       */
      tooltipInfo() {
        const info = {
          text: 'You haven’t finished this renewal collection.',
          cta: 'Finish renewal.',
          type: 'renewal',
        };

        if (this.rowData.type === 'Full marketing') {
          if (this.isInSetup) {
            info.text = 'Market event setup in progress. Carrier invites for this market event will be sent '
              + 'once all no prior coverage products are set up by ThreeFlow.';
            info.cta = '';
            info.type = '';
          } else {
            info.text = 'You haven’t finished this marketing.';
            info.cta = 'Finish marketing.';
            info.type = 'go-to-market';
          }
        }

        return info;
      },
      /**
       * Determine if this RFP is in a completed state
       *
       * @returns {boolean}
       */
      isCompleted() {
        return !['rfp_setup_started', 'rfp_started', 'rfp_modified_renewal_conversion'].includes(this.rowData.state);
      },
      /**
       * Determine if this RFP is in setup started
       *
       * @returns {boolean}
       */
      isInSetup() {
        return this.rowData.state === 'rfp_setup_started';
      },
    },
  };
</script>

<style scoped lang="scss">
  .cta {
    display: inline-block;
  }

  .icon {
    color: $tf-orange;
    margin-left: 8px;
    transform: translateY(2px);

    &.exclamation-icon {
      color: $tf-red;
    }
  }

  ::v-deep .tf-popper.tf-tooltip {
    white-space: normal;
    max-width: 225px;
  }

  .tooltip-events-container {
    ::v-deep {
      .tf-tooltip {
        max-width: 175px;
      }
    }
  }
</style>
